import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Clear';
import DialogContent from '@material-ui/core/DialogContent';
import { useTranslation } from 'utils/modifiedTranslation';
import DialogContentBody from './DialogContentBody';

export const DeleteConfirmationDialog = ({
  isOpen, closeDialog, isFullScreen, confirm, message,
}) => {
  const { t } = useTranslation();
  const dialogContentButtons = [
    {
      key: 1,
      value: t('questionnaire.compound_question_answer.delete'),
      color: 'primary',
      variant: 'contained',
      size: 'large',
      onClick: confirm,
      style: {
        padding: '10px 50px',
        borderRadius: 23,
        fontWeight: 'bold',
      },
    },
    {
      key: 2,
      value: t('questionnaire.compound_question_answer.close'),
      color: 'primary',
      variant: 'text',
      size: 'large',
      onClick: closeDialog,
      style: { padding: '10px 50px' },
    },
  ];

  return (
    <Dialog
      onClose={closeDialog}
      aria-labelledby="delete-confirmation-dialog"
      open={isOpen}
      scroll="paper"
      maxWidth="xs"
      fullScreen={isFullScreen}
    >
      <DialogActions>
        <IconButton onClick={closeDialog}>
          <CloseIcon color="primary" />
        </IconButton>
      </DialogActions>
      <DialogContent
        style={{
          padding: 20,
          margin: 0,
        }}
      >
        <DialogContentBody
          closeDialog={closeDialog}
          message={message}
          dialogContentButtons={dialogContentButtons}
        />
      </DialogContent>
    </Dialog>
  );
};

DeleteConfirmationDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeDialog: PropTypes.func.isRequired,
  confirm: PropTypes.func.isRequired,
  isFullScreen: PropTypes.bool.isRequired,
  message: PropTypes.string.isRequired,
};
